const rangepicker = ['测评开始时间', '测评结束时间']
const labelCol = { span: 3 }
const wrapperCol = { span: 15 }
const COlUMNS = [
  {
    title: '等第名称',
    dataIndex: 'rankName',
    width: '92px',
    scopedSlots: { customRender: 'rankName' }
  },
  {
    title: '分数区间',
    dataIndex: 'section',
    scopedSlots: { customRender: 'section' }
  }
]
const LEVEL_1 = [
  {
    key: '0',
    rankName: 'A',
    bottom: 85,
    top: 100
  },
  {
    key: '1',
    rankName: 'B',
    bottom: 75,
    top: 85
  },
  {
    key: '2',
    rankName: 'C',
    bottom: 60,
    top: 75
  },
  {
    key: '3',
    rankName: 'D',
    bottom: 0,
    top: 60
  }
]
const LEVEL_2 = [
  {
    key: '0',
    rankName: '优',
    bottom: 85,
    top: 100
  },
  {
    key: '1',
    rankName: '良',
    bottom: 75,
    top: 85
  },
  {
    key: '2',
    rankName: '中',
    bottom: 60,
    top: 75
  },
  {
    key: '3',
    rankName: '差',
    bottom: 0,
    top: 60
  }
]
const LEVEL_3 = [
  {
    key: '0',
    rankName: '优秀',
    bottom: 85,
    top: 100
  },
  {
    key: '1',
    rankName: '良好',
    bottom: 75,
    top: 85
  },
  {
    key: '2',
    rankName: '合格',
    bottom: 60,
    top: 75
  },
  {
    key: '3',
    rankName: '须努力',
    bottom: 0,
    top: 60
  }
]

const SUBJECT_TYPE_LIST = [
  {
    type: 'ORAL',
    typeName: '口语',
    tikuName: 'oral'
  },
  {
    type: 'LISTENING',
    typeName: '听力',
    tikuName: 'listen'
  },
  {
    type: 'NORMAL',
    typeName: '笔试',
    tikuName: 'write'
  }
]
const TERM_LIST = [
  { termId: 1, termName: '上册' },
  { termId: 2, termName: '下册' }
]

export {
  COlUMNS,
  rangepicker,
  labelCol,
  wrapperCol,
  LEVEL_1,
  LEVEL_2,
  LEVEL_3,
  SUBJECT_TYPE_LIST,
  TERM_LIST
}
